import { Injectable } from "@angular/core";
import {
  SearchClient,
  SearchQueryModel,
  SearchResultModel,
} from "src/domain/client";
import { ChannelRequestService } from "./channel-request.service";
@Injectable({
  providedIn: "root",
})
export class SearchService {
  constructor(private channelRequestService: ChannelRequestService) {}

  getSearchResult(
    searchQueryModel: SearchQueryModel,
  ): Promise<SearchResultModel> {
    if (!this.channelRequestService.channelRequest?.channelRequestId) {
      return Promise.reject(new Error("No channelRequestId specified"));
    }
    return new SearchClient().query(
      this.channelRequestService.channelRequest.channelRequestId,
      searchQueryModel,
    );
  }
}
